import { GameDiscoveryInterface } from '@/components/venue/GameDiscoveryInterface';
import { TeamGameRequestInterface } from '@/components/venue/TeamGameRequestInterface';
import { ScorekeeperGameRequestInterface } from '@/components/venue/ScorekeeperGameRequestInterface';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import Header from '@/components/Header';
import MobileHeader from '@/components/mobile/MobileHeader';
import Footer from '@/components/Footer';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import { useUserRole } from '@/hooks/useUserRole';

export default function GameDiscovery() {
  const { permissions } = useUserRole();
  const isScorekeeper = permissions.role === 'scorekeeper';

  return (
    <>
      <Header />
      <MobileHeader />
      <div className="min-h-screen bg-background pt-16 pb-20">{/* Fixed padding for proper header visibility */}
        <div className="container mx-auto px-4 py-8 space-y-8">
          <div className="text-center space-y-4">
            <h1 className="text-4xl font-bold text-foreground">Find & Join Games</h1>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Discover available games or join with a game code
            </p>
          </div>

          <Tabs defaultValue="browse" className="w-full">
            <TabsList className="grid w-full grid-cols-2 h-12 bg-muted">
              <TabsTrigger value="browse" className="text-base">Browse Games</TabsTrigger>
              <TabsTrigger value="join-code" className="text-base">
                {isScorekeeper ? 'Apply to Scorekeeper' : 'Join with Code'}
              </TabsTrigger>
            </TabsList>

            <TabsContent value="browse" className="mt-6">
              <GameDiscoveryInterface />
            </TabsContent>

            <TabsContent value="join-code" className="mt-6">
              {isScorekeeper ? (
                <ScorekeeperGameRequestInterface />
              ) : (
                <TeamGameRequestInterface />
              )}
            </TabsContent>
          </Tabs>
        </div>
      </div>
      <Footer />
      <MobileBottomNav />
    </>
  );
}